import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';
export interface IPromotorFormMeta {
  id: FormInputMeta,
  bank: FormInputMeta,
  agence: FormInputMeta,
  status: FormInputMeta,
  type: FormInputMeta,

  // Schema
  schema: any,
}

const PromotorFormMeta: IPromotorFormMeta = {} as IPromotorFormMeta

PromotorFormMeta.id = {
  name: 'id',
  type: 'text',
  label: 'ID',
  placeholder: 'ID',
  validation: yup.string().required(),
};

PromotorFormMeta.bank = {
  name: 'bank',
  type: 'text',
  label: 'Banque',
  placeholder: 'Banque',
  validation: yup.string().required(),
};

PromotorFormMeta.agence = {
  name: 'agence',
  type: 'text',
  label: 'Agence',
  placeholder: 'Agence',
  validation: yup.string().required(),
};

PromotorFormMeta.status = {
  name: 'status',
  type: 'select',
  label: 'Status',
  // placeholder: 'Status',
  validation: yup.string().required(),
};

PromotorFormMeta.type = {
  name: 'type',
  type: 'radio',
  label: 'Type',
  // placeholder: 'Groupe des Banques',
  options: [
    {
      label: 'Inidividuel',
      value: 'individual'
    },
    {
      label: 'Compagnie',
      value: 'company',
    },
  ],
  validation: yup.string().required(),
};

const validationSchema = getValidationSchema(PromotorFormMeta)
PromotorFormMeta.schema = yup.object().shape(validationSchema);

export default PromotorFormMeta;